import { ProjectPreviewFragmentFragment } from '@lopo-tech/lopo-api'
import classNames from 'classnames'
import React from 'react'
import { useHistory } from 'react-router-dom'
import Icon from 'src/components/forms/icon/icon'
import NavigationItem from 'src/components/navigation_item/navigation_item'
import { CLASS_PREFIX } from 'src/constants'
import { textResources } from 'src/lang/de'
import { COLOR_TYPE_PRIMARY } from 'src/utils/color'
import InfrastructureProjectTile from '../infrastructure_projects_tile/infrastructure_project_tile'
import './infrastructure_project_list_section.scss'

type Props = {
  icon?: React.ReactNode;
  title: string;
  count?: number;
  viewAllHref?: string;
  className?: string;
  projects: ProjectPreviewFragmentFragment[] | undefined;
};

const cls = `${CLASS_PREFIX}infrastructure-project-list-section`

const t = textResources.projects

export const InfrastructureProjectListSection: React.FC<Props> = ({
  icon,
  title,
  count,
  viewAllHref,
  projects,
  className
}) => {
  const history = useHistory()
  return (
    <section className={classNames(cls, className)}>
      <div className={`${cls}__header`}>
        <div className={`${cls}__title-wrap`}>
          {icon}
          <h2 className={`${cls}__title`}>{title}</h2>
          {typeof count === 'number'
            ? (
              <span className={`${cls}__count`}>({count})</span>
            )
            : null}
        </div>
        {viewAllHref && (
          <NavigationItem
            className={`${cls}__view-all`}
            onClick={() => history.push(viewAllHref)}
          >
            <span>{t.overview.viewAll}</span>
            <Icon name={'arrow-right'} size={20} color={COLOR_TYPE_PRIMARY} />
          </NavigationItem>
        )}
      </div>

      <div className={`${cls}__list`}>
        {projects?.map((project) => (
          <InfrastructureProjectTile key={project.id} project={project} />
        ))}
      </div>
    </section>
  )
}
